import React from 'react';
import { Box } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

// The primary conversion CTA. Always amber — never teal.
// Props: to (route), onClick, size ('sm'|'md'|'lg'), fullWidth, disabled, children, sx
export default function AmberButton({ children, to, onClick, size = 'md', fullWidth = false, disabled = false, sx = {}, ...rest }) {
  const pad = size === 'lg' ? '15px 24px' : size === 'sm' ? '8px 16px' : '11px 20px';
  const fs  = size === 'lg' ? '16px' : size === 'sm' ? '13px' : '15px';
  const br  = size === 'sm' ? '8px' : '11px';

  const base = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '9px',
    background: disabled ? 'rgba(245,165,36,.4)' : '#f5a524',
    color: '#241200',
    fontFamily: "'Lexend', sans-serif",
    fontWeight: 600,
    fontSize: fs,
    padding: pad,
    borderRadius: br,
    border: 'none',
    cursor: disabled ? 'not-allowed' : 'pointer',
    textDecoration: 'none',
    boxShadow: disabled ? 'none' : '0 10px 28px rgba(245,165,36,.3)',
    transition: 'background .15s, transform .15s, box-shadow .15s',
    width: fullWidth ? '100%' : 'auto',
    '&:hover': disabled ? {} : {
      background: '#ffb84d',
      transform: 'translateY(-1px)',
      boxShadow: '0 12px 30px rgba(245,165,36,.35)',
    },
    ...sx,
  };

  if (to) {
    return (
      <Box component={RouterLink} to={to} sx={base} {...rest}>
        {children}
      </Box>
    );
  }

  return (
    <Box component="button" onClick={disabled ? undefined : onClick} disabled={disabled} sx={base} {...rest}>
      {children}
    </Box>
  );
}
